import { BrowserRouter, Route, Link, Routes } from 'react-router-dom';
import {
  Suspense,
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState
} from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HomeScreen from './screens/HomeScreen';
import axios from 'axios';
import LoadingBox from './components/LoadingBox';
import Header from './components/Header';
import ServicesScreen from './screens/ServicesScreen';
import Footer from './components/Footer';

function App() {
  const [language, setLanguage] = useState("el");
  return (
    <BrowserRouter>
        <ToastContainer position="bottom-center" limit={1} />
        <Header onLanguageChange={setLanguage} />
        <main>
          <Routes>
            <Route path="/" element={<HomeScreen lang={language} />} />
            {/* <Route path="/services" element={<ServicesScreen />} /> */}
          </Routes>
        </main>
        <Footer />
    </BrowserRouter>
  );
}

export default App;
